module.exports = __webpack_public_path__ + "media/images/pic/hero/video-bottom-f65f0cf46dd2e5b8f98b3dcd7c286b2b.svg";